/* 
 * Click nbfs://nbhost/SystemFileSystem/Templates/Licenses/license-default.txt to change this license
 * Click nbfs://nbhost/SystemFileSystem/Templates/Other/javascript.js to edit this template
 */


/*
  <search id='sg-sidebar-search' >
            <form id='sg-search'>
                <input id='sg-search-input' type="textfield" value=""
                     placeholder="<?php echo Text::_('COM_SNAPGLOBE_SEARCH_PLACEHOLDER'); ?>">
                <div style="border-radius: 0px;" role='cancel-button' class="text-black bg-grey">
                    <span class="bi bi-backspace"></span>
                </div>
                <div class="text-white bg-primary" role='query-button'>
                    <span class="bi bi-search"></span>
                </div>

            </form>
   </search> 
 
*/


export class SearchByText {
    #cancelBtn;
    #queryBtn;
    #queryInput;
    #searchInput;
    #snapResults;
    #apiSearch;
    #searchForm;

    constructor(apiSearch, snapResults) {
        this.#apiSearch = apiSearch;
        this.#snapResults = snapResults;
        this.init();
    }

    init() {
        this.#cancelBtn = document.querySelector("div[role='cancel-button']");
        this.#queryBtn = document.querySelector("div[role='query-button']");
        this.#queryInput = document.getElementById('sg-search-input');
        this.#searchInput = document.getElementById('sg-search-input');
        this.#searchForm =document.getElementById('sg-search');
        
        this.#cancelBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.#searchForm.reset();
        });

        this.#queryBtn.addEventListener('click', (e) => {
            e.preventDefault();
            let value = escape(this.#searchInput.value);

            fetch(`${this.#apiSearch}?q=${value}`).then(async (dataPromise) => {
                let response = await dataPromise;
                let results = await response.json();
                if (results.data) {
                    this.#snapResults.update(results.data.attributes);
                } else {
                    //TODO: messaggio errore
                }
            });

        });

        this.#queryInput.addEventListener('keydown', (e) => {
            if (event.keyCode === 13) {
                e.preventDefault();
                let event = document.createEvent('MouseEvents');
                event.initEvent('click', true, true);
                this.#queryBtn.dispatchEvent(event);
            }
        });

    }

}